import './ServicesInfoBlock.scss'
import './ServicesInfoCell.scss'
import type { ReactNode } from 'react'
import { StructuredText } from 'react-datocms'
import type { ServiceInfoBlock } from '#src/data/data.js'

interface ServicesInfoBlockProps {
  serviceInfo: ServiceInfoBlock
}

export function ServicesInfoBlock(props: ServicesInfoBlockProps): ReactNode {
  const { serviceInfo } = props

  return (
    <section className="services__info-block">
      <h2 className="services__info-heading">{serviceInfo.title}</h2>
      <div className="services__info-block_inner">
        {serviceInfo.cells.map(cell => (
          <div className="services__info-cell" key={cell.title}>
            <div className="services__overline" />
            <div className="services__info-cell-text">
              <h4 className="services__info-cell-title">{cell.title}</h4>
              <div className="services__info-cell-description">
                <StructuredText data={cell.description} />
              </div>
            </div>
            <div className="services__underline_bottom" />
          </div>
        ))}
      </div>
    </section>
  )
}
